import styled from 'styled-components';

import { COLOR_1 } from '../../../config';
import { backgroundSideBar, col_error } from '../../../globals';


export const StyledCheckBox = styled.div`
  padding: 0 6px 0 6px;
  margin: 2px 0 15px 0;

    input {
        position: absolute;
        height: 1px; 
        width: 1px;
        overflow: hidden;
        clip: rect(1px 1px 1px 1px); /* IE6, IE7 */
        clip: rect(1px, 1px, 1px, 1px);
    }

    label {
        display: block;
        position: relative;
        padding: 0 1.5rem 0 0;
    }

    label::before {
        content: '';
        position: relative;
        display: inline-block;
        margin-right: 10px;
        top: 6px;
        width: 25px;
        height: 25px;
        background: white;
        border: 2px solid #c1c1c1;
    }   

    input:checked + label::before {
        background: #2e3647;
    }

    input:checked + label::after {
        content: '';
        position: absolute;
        top: 12px;
        left: 6px;
        border-left: 3px solid white;
        border-bottom: 3px solid white;
        height: 8px;
        width: 13px;
        transform: rotate(-45deg);
    }

    input:focus + label::before {
        border: 2px solid ${COLOR_1};
        box-shadow: 0 0px 6px #ccc;
    }

    label.error::before {
        border: 2px solid ${col_error};
    }
  
`;



// WEBPACK FOOTER //
// ./src/common/CheckBox/styles/StyledCheckBox.js